<style lang="css">

#search {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-right: 40px;
    margin-bottom: 30px;
}
.v-calendar-daily__scroll-area {
    overflow: auto !important;
}
.v-calendar-daily__head {
    margin-right: 0 !important;
}

</style>

<template>

<div class="pa-5">
    <v-row align="center" style="height:20px">
        <v-col></v-col>
        <v-btn icon class="ma-1" @click="$refs.calendar.prev()">
            <v-icon size="30" color="black">mdi-chevron-left</v-icon>
        </v-btn>
        <h5 style="padding-top:8px">
        {{start}} - {{end}} {{month}}
      </h5>
        <v-btn icon class="ma-1" @click="$refs.calendar.next()">
            <v-icon size="30" color="black">mdi-chevron-right</v-icon>
        </v-btn>
        <v-col></v-col>
    </v-row>

    <v-row v-if="Object.keys(techColors).length > 0" style="margin-bottom:10px; height:30px" align="center">
        <v-col cols="1"></v-col>
        <v-chip-group column>
            <v-chip v-bind:key="name" v-for="(color,name) in techColors" :color="color" text-color="white" small>
                {{name}}
            </v-chip>
        </v-chip-group>
    </v-row>
    <v-row v-else style="height:25px" ></v-row>

    <v-calendar ref="calendar"  v-model="value" :event-color="getEventColor" :weekdays="[1,2,3,4,5,6,0]" type="week" :events="events" @click:event="showEvent" @change="weekChange">
        <template slot="event" slot-scope="event" style="top:109% !important">
            <div style="margin-left:10px; margin-top:10px">
                {{event.event.data.name}}
                <br/>
                <small>
                  {{event.event.data.status}}
                </small>
            </div>
        </template>
    </v-calendar>

    <v-btn absolute dark fab bottom right color="primary" id="search" @click="newJob = true">
        <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="newJob" transition="dialog-bottom-transition" fullscreen>
        <v-card fill-height>
            <v-toolbar dark dense color="primary">
                <v-btn icon dark @click="newJob = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>New Job</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-container>
                <v-row>
                    <v-col cols="10">
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                                Customer Details:
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.customer.fname" dense filled color="purple darken-2" label="First Name:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.customer.lname" dense filled color="purple darken-2" label="Last Name:" />
                            </v-col>
                        </v-row>
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.customer.phone" dense filled color="purple darken-2" label="Phone:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.customer.company" dense filled color="purple darken-2" label="Company:" />
                            </v-col>
                        </v-row>
                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.customer.email" dense filled color="purple darken-2" label="Email:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <v-select v-model="job.customer.channel" :items="channels" filled label="Channel:"></v-select>
                            </v-col>
                        </v-row>



                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                            </v-col>

                            <v-col cols="5">
                                <div>
                                    <small class="text-info">Owner of vehicle:</small>
                                    <v-switch class="shrink mr-0 mt-0" v-model="job.customer.owner"></v-switch>
                                </div>

                            </v-col>
                            <v-col cols="5">

                            </v-col>
                        </v-row>

                        <v-divider></v-divider>
                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">
                                Job Details:
                            </v-col>
                            <v-col cols="5">
                                <v-select v-model="job.jobType" :items="jobTypes" filled label="Job Type:"></v-select>
                            </v-col>
                            <v-col cols="5">
                                <v-select v-model="locSelect" :item-value="item => item.id" :item-text="item => item.name" @input="changeLocation" :items="locations" filled label="Location:">
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row align="center" v-if="job.jobType != null" style="min-height: 50px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <small class="text-primary">Selected Vehicle:</small>
                                <div v-if="job.make != null">
                                    <v-chip class="ma-1" @click:close="clearVehicle" color="primary" text-color="white" close>
                                        Make: {{job.make}}
                                    </v-chip>
                                    <v-chip class="ma-1" @click:close="clearVehicle" color="primary" text-color="white" close>
                                        Model: {{job.model}}
                                    </v-chip>
                                    <v-chip class="ma-1" @click:close="clearVehicle" color="primary" text-color="white" close>
                                        Year: {{job.year}}
                                    </v-chip>
                                </div>
                            </v-col>
                            <v-col cols="5">
                                <v-btn rounded color="primary" @click="showVehDialog">Select Vehicle</v-btn>
                            </v-col>
                        </v-row>

                        <v-row v-if="job.jobType != null && job.jobType.includes('KEY') && job.make != null" style="min-height: 50px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <small v-if="key == null" class="text-info">Selected Key:</small>
                                <small v-else class="text-info">Selected Key: (Stock: <span class="text-success">{{key.stock}}</span> Price: <span class="text-success">{{key.price}}</span> )</small>
                                <div v-if="key != null">
                                    <v-avatar left>
                                        <v-img v-bind:src="key.image"></v-img>
                                    </v-avatar>
                                    <v-chip class="ma-1" color="green" @click:close="clearKey" text-color="white" close>
                                        OEM: {{key.key.oem}}
                                    </v-chip>
                                    <v-chip class="ma-1" color="green" @click:close="clearKey" text-color="white" close>
                                        FCC: {{key.key.fcc}}
                                    </v-chip>
                                    <v-chip class="ma-1" color="green" @click:close="clearKey" text-color="white" close>
                                        IC: {{key.key.ic}}
                                    </v-chip>
                                </div>
                            </v-col>
                            <v-col cols="5">
                                <v-autocomplete v-model="key" @input="keyChange" :item-value="item => item" :filter="filterKeys" :items="keys" filled label="Available Keys:">
                                    <v-list-tile name="ava1" class="pa-2" slot="item" slot-scope="{item}">
                                        <v-avatar left>
                                            <v-img :v-bind:src="item.key.image"></v-img>
                                        </v-avatar>
                                        {{item.key.oem}}
                                    </v-list-tile>
                                    <v-list-tile name="ava2" class="pa-2" slot="selection" slot-scope="{item}">
                                        <v-avatar left>
                                            <v-img :v-bind:src="item.key.image"></v-img>
                                        </v-avatar>
                                        {{item.key.oem}}
                                    </v-list-tile>
                                </v-autocomplete>
                            </v-col>

                            <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">
                                    Vehicle Details:
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.vin_num" dense filled color="purple darken-2" label="VIN Number:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.colour" dense filled color="purple darken-2" label="Color:" />
                            </v-col>
                        </v-row>
                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.lisence" dense filled color="purple darken-2" label="Lisence Plate">
                                </v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.caa" dense filled color="purple darken-2" label="CAA:" />
                            </v-col>
                        </v-row>
                        
                        
                        </v-row>

                         <v-row>
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.quote" dense filled color="purple darken-2" label="Quote:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="5">
                                </v-col>
                        </v-row>
                        

                        <v-divider></v-divider>

                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">
                                Time/Technician:
                            </v-col>
                            <v-col cols="5">
                                <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="job.date" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="job.date" label="Date" prepend-inner-icon="event" readonly v-bind="attrs" v-on="on" filled></v-text-field>
                                    </template>
                                    <v-date-picker v-model="job.date" no-title scrollable :show-current="true">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn text color="primary" @click="$refs.menu.save(job.date)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="5">
                                <v-select v-model="userSelect" @input="changeUser" :item-value="item => item" :item-text="item => item.username" :items="users" filled label="Technician:"></v-select>
                            </v-col>
                        </v-row>

                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">

                            </v-col>
                            <v-col cols="2">
                                <v-select v-model="job.from" :items="hours" filled label="Start Time:"></v-select>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="2">
                                <v-select v-model="job.to" :items="hours" filled label="End Time:"></v-select>
                            </v-col>
                            <v-col cols="2" align="center">
                                <small v-if="timeInfoStatus" class="text-success">{{timeInfo}}</small>
                                <small v-else class="text-danger">{{timeInfo}}</small>
                            </v-col>
                            <v-col cols="2">
                                <v-btn color="primary" @click="checkAvailability">Check Availability</v-btn>
                            </v-col>

                        </v-row>
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.address" dense filled color="purple darken-2" label="Address:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="5"></v-col>
                        </v-row>
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="5">
                                <v-text-field v-model="job.opRemarks" dense filled color="purple darken-2" label="Remarks:" />
                            </v-col>
                            <v-col>

                            </v-col>
                        </v-row>
                        <v-row style="margin-top:2%">
                            <v-col cols="3" class="text-info">
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="success" @click="submit">Submit</v-btn>
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="info" @click="reset">Reset</v-btn>
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="error" @click="hide">Cancel</v-btn>
                            </v-col>
                            <v-col cols="1"></v-col>
                        </v-row>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="5">

                    </v-col>
                </v-row>


            </v-container>
        </v-card>
    </v-dialog>

    <v-dialog v-model="vehDialog" max-width="500px" style="margin-top:4%">
        <v-card>
            <v-container>
                <v-row justify="center" style="height: 60px;">
                    <v-col cols="8">
                        <v-select v-model="make" :items="makes" @input="makeChange" outlined dense label="Select Make:"></v-select>
                    </v-col>
                </v-row>
                <v-row justify="center" style="height: 60px;">
                    <v-col cols="8">
                        <v-select v-model="model" :items="models" @input="modelChange" outlined dense label="Select Model:"></v-select>
                    </v-col>
                </v-row>
                <v-row justify="center" style="height: 60px;">
                    <v-col cols="8">
                        <v-select v-model="year" :items="years" outlined dense label="Select Year:"></v-select>
                    </v-col>
                </v-row>
                
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="hideVehDialog">Close</v-btn>
                <v-btn color="blue darken-1" text @click="addVehicle">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

     <JobDialog v-if='details' :jobInfo='jobInfo' :show="details" @close="details = false" />


</div>

</template>

<script>

import Vue from 'vue'
import Utils from './kalendar/utils.js'
import { gmapApi } from 'vue2-google-maps';
import { DateTime } from 'luxon'
import Kalendar from './kalendar/kalendar-container.vue'
import JobDialog from './JobDialog.vue'


let today = new Date()
let year = today.getFullYear() + '',
    month = (today.getMonth() + 1 + '').padStart(2, 0),
    day = (today.getDate() + '').padStart(2, 0)

const currentDay = `${year}-${month}-${day}T00:00:00.000Z`

export default {
name: 'Calendar',
    components: {
        JobDialog,
    },
    created() {
            this.getAllChannels()
            this.getAllJobTypes()
            this.getTechnicians()
            
            this.job = this.$store.state.job
        },
       

        

        data() {
            return {
                events: [],
                calendar_settings: {
                    cell_height: 10,
                    scrollToNow: true,
                    current_day: currentDay,
                    military_time: false,
                    read_only: true,
                    hide_days: [],
                    overlap: false,
                    past_event_creation: false,
                    day_starts_at: 5,
                    day_ends_at: 24
                },
                jobTypes: [],
                keys: [],
                key: null,
                vehicle: null,
                models: [],
                makes: [],
                value: '',
                menu: false,
                years: [],
                model: null,
                make: null,
                year: null,
                channels: [],
                jobs: [],
                events: [],
                hours: [
                    '05:00 AM',
                    '06:00 AM',
                    '07:00 AM',
                    '08:00 AM',
                    '09:00 AM',
                    '10:00 AM',
                    '11:00 AM',
                    '12:00 PM',
                    '01:00 PM',
                    '02:00 PM',
                    '03:00 PM',
                    '04:00 PM',
                    '05:00 PM',
                    '06:00 PM',
                    '07:00 PM',
                    '08:00 PM',
                    '09:00 PM',
                    '10:00 PM',
                    '11:00 PM'
                ],
                job: null,
                jobInfo: null,
                filteredJobHistorys: null,
                timeInfo: '',
                users: [],
                timeInfoStatus: false,
                locSelect: null,
                userSelect: null,
                newJob: false,
                details: false,
                techColors: {},
                vehDialog: false,
                start: 2,
                end: 3,
                month: "Sep",
                options: null
            }
        },
        computed: {
            google: gmapApi,
            locations() {
                return this.$store.state.locations
            }
        },
        watch: {
            users(current, old) {},
                locations(current, old) {}
        },
        methods: {
            formatDate(date) {
                const formattedDate = DateTime.fromMillis(date).toFormat("dd yyyy LLL");
                return formattedDate;
            },  
            reset() {
                    this.$store.state.job = this.job = {
                        customer: {
                            phone: null,
                            fname: null,
                            lname: null,
                            caa_card: null,
                            company: null,
                            channel: null,
                            email: null,
                        },
                        from: null,
                        to: null,
                        date: null,
                        jobType: null,
                        address: null,
                        latitude: null,
                        longitude: null,
                        quote: null,
                        opRemarks: null,
                        user: null,
                        oem: null,
                        make: null,
                        model: null,
                        year: null,
                        colour: null,
                        vin_num: null,
                        lisence: null,
                        caa: null,

                    }
                    
                    this.key = null;
                    this.timeInfoStatus = false;
                    this.timeInfo = '';
                    this.locSelect = null;
                    this.userSelect = null;
                },
                getAllJobTypes() {
                    this.$api
                        .getAllJobTypes()
                        .then(res => {
                            if (res.status == 200) {
                                this.jobTypes = res.data
                            }
                        })
                        .catch(error => {})
                },
                getAllChannels() {
                    this.$api.getAllChannels().then(res => {
                        if (res.status == 200) this.channels = res.data
                    })
                },

                submit: async function() {
                    if (!this.timeInfoStatus) {
                        this.$toasted.error('Make sure technician is available').goAway(1200)
                        return
                    }
                    try {
                        const mapRef = await this.$gmapApiPromiseLazy();
                        if(!mapRef){
                            return;
                        }
                        const geocoder = new google.maps.Geocoder();
                        const address = await geocoder.geocode({ 'address' : this.job.address });
                        if (address.results) {
                            const latitude = address.results[0].geometry.location.lat();
                            const longitude = address.results[0].geometry.location.lng();
                            this.job.latitude = latitude;
                            this.job.longitude = longitude;
                        }
                    }
                    catch {
                        this.$toasted.error('Make sure address is correct').goAway(1200)
                        return;
                    }          
                    this.$overlay.show(this)
                    this.$api
                    .addJob(this.job)
                    .then(res => {
                        if (res.status == 200) {
                            this.hide()
                            this.weekChange(this.options);
                            this.reset()
                        }
                        this.$overlay.hide()
                    })
                    .catch(() => {
                        this.$overlay.hide()
                    })
                },
                changeLocation(val) {
                    this.job.loc = val;
                    this.getLocationTechnicians(val);
                    this.key = null;
                    this.users = [];
                    this.userSelect = null;
                    if (this.job.jobType.includes('KEY') && this.job.make != null) {
                        this.$api
                            .getPriceAndStock(this.job.make, this.job.model, this.job.year, this.job.loc)
                            .then(res => {
                                if (res.status == 200) {
                                    this.keys = res.data
                                    this.$store.state.keys = this.keys
                                }
                            })
                            .catch(err => {
                                this.$toasted.error('Choose a location').goAway(1200)
                            })
                    }

                },
                changeUser(val) {
                    this.job.user = val.email
                },
                keyChange(val) {
                    if (val != null) {
                        this.job.oem = val.key.oem;
                        this.key = val;
                    }
                },
                showVehDialog() {
                    if (this.locSelect == null) {
                        this.$toasted.error("Please select a location.").goAway(1200);
                        return;
                    }
                    this.vehDialog = true;
                    if (this.makes != null)
                        this.$api
                        .getMakes()
                        .then(response => {
                            if (response.status == 200) {
                                this.makes = response.data
                            }
                        })
                        .catch(error => {})
                },
                hideVehDialog() {
                    this.vehDialog = false;
                    this.make = this.model = this.year = null
                },
                clearVehicle() {
                    this.job.make = this.job.model = this.job.year = null;
                    this.key = null;
                    this.keys = [];
                },
                clearKey() {
                    this.key = null;
                },
                makeChange() {
                    this.model = ''
                    this.year = ''
                    if (this.make != null) {
                        this.$api.getModels(this.make).then(response => {
                            if (response.status == 200) {
                                this.models = response.data
                            }
                        })
                    }
                },
                modelChange() {
                    this.year = ''
                    if (this.make != null && this.model != null) {
                        this.$api.getYears(this.make, this.model).then(response => {
                            if (response.status == 200) {
                                this.years = response.data
                            }
                        })
                    }
                },
                addVehicle() {
                    this.job.make = this.make
                    this.job.model = this.model
                    this.job.year = this.year
                    if (this.job.jobType.includes('KEY')) {
                        this.$api
                            .getPriceAndStock(this.make, this.model, this.year, this.job.loc)
                            .then(res => {
                                if (res.status == 200) {
                                    this.keys = res.data
                                    this.$store.state.keys = this.keys
                                }
                            })
                            .catch(err => {
                                this.$toasted.error('Choose a location').goAway(1200)
                            })
                    }
                    this.hideVehDialog();
                },
                checkAvailability() {
                    if (this.job.date == null) {
                        this.timeInfo = 'Please select a date'
                        this.timeInfoStatus = false
                        return
                    }

                    if (this.job.user == null) {
                        this.timeInfo = 'Please select a technician'
                        this.timeInfoStatus = false
                        return
                    }

                    if (this.job.to == null || this.job.from == null) {
                        this.timeInfo = 'Invalid Start/End Time'
                        this.timeInfoStatus = false
                        return
                    }

                    let to = this.getTwentyFourHourTime(this.job.to)
                    let from = this.getTwentyFourHourTime(this.job.from)

                    if (from >= to) {
                        this.timeInfo = 'Invalid Start/End Time'
                        this.timeInfoStatus = false
                        return
                    }

                    this.$api.checkAvailability(this.job.user, this.job.to, this.job.from, this.job.date).then(res => {
                        if (res.status == 200) {
                            let x = res.data
                            if (x == 0) {
                                this.timeInfo = 'Technician is available'
                                this.timeInfoStatus = true
                            } else {
                                this.timeInfo = 'Technician is not available'
                                this.timeInfoStatus = false
                            }
                        }
                    })
                },
                getDateFromString(s) {
                    let hour = Number(s.substring(0, 2))
                    let d = new Date(this.job.date)
                    d.setHours(hour)
                    return d
                },
                hide() {
                    this.newJob = false;
                },
                showEvent({
                    nativeEvent, event
                }) {
                    this.showJobInfo(event.data.id)
                    this.showhis(event.data.id)
                    
                },
                showJobInfo(jobID) {
                    this.$overlay.show(this)
                    this.$api
                        .getJobById(jobID)
                        .then(res => {
                            if (res.status == 200) {
                                this.jobInfo = res.data
                                console.log(this.jobInfo)
                                this.details = true
                            }
                            this.$overlay.hide()
                        })
                        .catch(error => {
                            this.$overlay.hide()
                        })
                },
                
                showhis(jobID) {
                  //  this.$overlay.show(this)
                    console.log("showhistory")
                    this.$api
                        .getHistoryOfJob(jobID)
                        .then(res => {
                            if (res.status == 200) {
                               const jobHistorys = res.data
                                this.filteredJobHistorys = jobHistorys.sort((a, b) => a.createDate - b.createDate);
                            }
                            //this.$overlay.hide()
                        })
                        .catch(error => {
                           // this.$overlay.hide()
                        })
                },

            
                getTwentyFourHourTime(amPmString) {
                    var d = new Date("1/1/2013 " + amPmString);
                    return d.getHours();
                },
                getReadableDate(date) {
                    var options = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                    }
                    return new Date(date).toLocaleDateString('en-US', options)
                },
                getReadableTime(date) {
                    let d = new Date(date).toUTCString()
                    let hours = d.substring(17, 19)
                    let minutes = d.substring(20, 22)
                    return this.formatAMPM(hours, minutes)
                },
                formatAMPM(hours, minutes) {
                    var ampm = hours >= 12 ? 'PM' : 'AM'
                    hours = hours % 12
                    hours = hours ? hours : 12
                    var strTime = hours + ':' + minutes + ' ' + ampm
                    return strTime
                },
                weekChange(options) {
                    this.options = options;
                    let day = options.start.date;
                    this.start = options.start.day;
                    this.end = options.end.day;
                    this.month = this.getMonth(options.end.month);
                    this.$api
                        .searchJobsByWeek(day)
                        .then(res => {
                            if (res.status == 200) {
                                this.jobs = res.data
                             
                                this.jobs.forEach(job => {
                                    let event = {
                                        name: job.data.name,
                                        start: job.from.replace(/T/, ' ')
                                            .replace(/\..+/, ''),
                                        end: job.to.replace(/T/, ' ')
                                            .replace(/\..+/, ''),
                                        data: job.data
                                    }
                                    this.events.push(event);
                                })
                            }
                        })
                        .catch(error => {})
                },
                getEventColor(event) {
                    let color = this.techColors[event.name]
                    if (color)
                        event.color = color
                    else
                        event.color = "blue"

                    return event.color
                },
                getMonth(num) {

                    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'November', 'December'][num - 1]
                },
                getLocationTechnicians(id) {
                    this.$api.getAllTechnicians(id).then(res => {
                        if (res.status == 200)
                        
                                this.users = res.data;
                    })
                },
                getTechnicians() {
                    this.$api.getAllTechnicians().then(res => {
                        if (res.status == 200)
                            for (var x = 0; x < res.data.length; x++) {
                                let name = res.data[x].fname + " " + res.data[x].lname;
                                let color = this.getDarkColor();
                                this.techColors[name] = color;
                            }
                    })
                },
                filterKeys(item, query, text) {
                    let key = item.key;
                    return (key.oem.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1 || key.fcc.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1 || key.ic.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1);
                },
                getDarkColor() {
                    var color = '#';
                    for (var i = 0; i < 6; i++) {
                        color += Math.floor(Math.random() * 10);
                    }
                    return color;
                },
                test(item) {
                    //console.log(item)
                }

        }
}

</script>
